/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrDataGridCoreModule } from './igr-data-grid-core-module';
import { IgrTextColumnModule } from './igr-text-column-module';
import { IgrNumericColumnModule } from './igr-numeric-column-module';
import { IgrDateTimeColumnModule } from './igr-date-time-column-module';
import { IgrTemplateColumnModule } from './igr-template-column-module';
import { IgrCheckboxModule } from "igniteui-react-inputs";
import { IgrInputGroupModule } from "igniteui-react-inputs";
import { IgrCheckboxList } from './igr-checkbox-list';
import { CheckboxList } from './CheckboxList';
import { TypeRegistrar } from "igniteui-react-core";
var IgrCheckboxListModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrCheckboxListModule() {
    }
    IgrCheckboxListModule.register = function () {
        IgrDataGridCoreModule.register();
        IgrTextColumnModule.register();
        IgrNumericColumnModule.register();
        IgrDateTimeColumnModule.register();
        IgrTemplateColumnModule.register();
        IgrCheckboxModule.register();
        IgrInputGroupModule.register();
        TypeRegistrar.registerCons('IgrCheckboxList', IgrCheckboxList);
        TypeRegistrar.registerCons('IgrCheckboxList', IgrCheckboxList);
        TypeRegistrar.register('CheckboxList', CheckboxList.$type);
    };
    return IgrCheckboxListModule;
}());
export { IgrCheckboxListModule };
//# sourceMappingURL=igr-checkbox-list-module.js.map
